import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { getAllTemplates } from "../redux/entities/formBuilderEntity";
import { Box, Card, TextField } from "@mui/material";
import NewFormDialogComponent from "../components/FormTemplates/NewFormDialogComponent";
import FormLayoutComponent from "../components/FormTemplates/FormLayoutComponent";

const TemplatesPage = () => {
  const templates = useAppSelector((state) =>
    Array.isArray(state.entities.formBuilder.allTemplates)
      ? state.entities.formBuilder.allTemplates
      : []
  );
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  const dispatch = useAppDispatch();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (templates.length === 0) {
      dispatch(getAllTemplates());
    }
  }, [templates.length, dispatch]);



  useEffect(() => {
    setFilteredTemplates(templates);
  }, [templates]);

  const handleSearch = (value) => {
    const search = value.toLowerCase().trim();

    if (!search) {
      setFilteredTemplates(templates);
      return;
    }

    const filtered = templates.filter((template) =>
      Object.values(template).some(
        (val) =>
          typeof val === "string" &&
          val.toLowerCase().includes(search)
      )
    );

    setFilteredTemplates(filtered);
  };

  return (
    <div className="templates-page d-flex mt-2 p-4 flex-column align-items-center">
      {/* <h3>All Form Templates</h3> */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: 2,
          minHeight: 40,
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* LEFT – SEARCH */}
        <TextField
          size="small"
          placeholder="Search templates..."
          onChange={(e) => handleSearch(e.target.value)}
          sx={{
            width: { xs: "100%", sm: 260 },
          }}
        />

        {/* PERFECTLY CENTERED TITLE */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <h3 style={{ margin: 0 }}>All Form Templates</h3>
        </Box>
      </Box>


      <Card
        className="templates-container"
        style={{ maxHeight: "79vh", overflow: "auto" }}
      >
        <div className="form-templates">
          {/* Button to open new form dialog */}
          <FormLayoutComponent
            createdFormLayout={false}
            setOpenDialog={setOpenDialog}
          />
          {/* Template Cards */}
          {filteredTemplates.map((template) => (
            <FormLayoutComponent
              key={template.id}
              template={template}
              createdFormLayout={true}
            />
          ))}
        </div>
      </Card>
      {/* New Form Dialog Component */}
      <NewFormDialogComponent
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
    </div>
  );
};

export default TemplatesPage;
